import React from 'react';

const Spacer = ({ children, ...props }) => {
    return (
        <div {...props} style={{ flex: 1 }}>{children}</div>
    );
}

export default Spacer